import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import './registerServiceWorker'

import axios from 'axios'
import jsonp from 'vue-jsonp'
import util from './util'
import progress from './components/progress'

Vue.use(jsonp, 15000)
Vue.use(util)
Vue.use(progress)

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'production') {
    store.commit('setApiURL', 'https://m-ethics.poscoenc.com:20449/api/')
    //store.commit('setApiURL', 'http://m-ethics2.midashelp.com/api/')
    //store.commit('setApiURL', 'http://192.168.120.211/api/')
}

Vue.prototype.$http = axios.create({
    baseURL: store.state.apiUrl,
    timeout: 10000,
    method: 'post',
    headers: {
        'Accept': 'application/json',
        'Content-type': 'application/x-www-form-urlencoded'
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js